<i18n>
{
  "de": {
    "privacy": "Datenschutz",
    "noInfo": "Bis jetzt keine Informationen."
  },
  "en": {
    "privacy": "Privacy Policy",
    "noInfo": "No information yet."
  }
}
</i18n>

<template>
  <section class="section mt-20">
    <div class="container">
      <div class="columns">
        <div
          class="column"
          :class="isMobileView ? 'is-hidden' : 'is-one-quarter'"
        >
          <sidenav />
        </div>
        <div class="column is-three-quarter">
          <div
            id="mainContent"
            class="box"
          >
            <h1 class="privacy-heading on-tile">
              {{ $t('privacy') }}
            </h1>
            <hr>
            <div
              v-if="hasPrivacy"
              class="content"
              v-html="artist.profile.configuration.legal.privacy"
            />
            <div v-else>
              {{ $t('noInfo') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import sidenav from '~/components/sidenav'

export default {
  components: { sidenav },

  data() {
    return {}
  },

  head() {
    return {
      title: this.artist.nickname
    }
  },

  computed: {
    ...mapState(['artist']),
    hasPrivacy() {
      return this.artist.profile.configuration &&
        this.artist.profile.configuration.legal &&
        this.artist.profile.configuration.legal.privacy
    }
  }
}
</script>
<style lang="scss">
@import 'assets/sass/_variables';

.unscrollable {
  overflow-y: hidden;
  max-height: 100vh;
}

.privacy-heading {
  color: $text !important;
}
</style>
